var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"erc721_view"},[(!_vm.isError && _vm.img)?_c('img',{attrs:{"src":_vm.parseURL(_vm.img)}}):_vm._e(),(_vm.isError)?_c('div',{staticClass:"err_cont"},[_c('p',[_c('fa',{attrs:{"icon":"unlink"}})],1)]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }